/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TenantsTenantIdRolesRoleNameDelete$Params {
  'Active-Tenant-Identifier': string;

/**
 * tenant identifier
 */
  tenantId: string;

/**
 * role name
 */
  roleName: string;
}

export function tenantsTenantIdRolesRoleNameDelete(http: HttpClient, rootUrl: string, params: TenantsTenantIdRolesRoleNameDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, tenantsTenantIdRolesRoleNameDelete.PATH, 'delete');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('tenantId', params.tenantId, {});
    rb.path('roleName', params.roleName, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

tenantsTenantIdRolesRoleNameDelete.PATH = '/tenants/{tenantId}/roles/{roleName}';
